const icon = "_arai1gif7ic";

export { icon };
import "./button.style.linaria.module.css";
//# sourceMappingURL=button.style.js.map
